import React, {
  lazy,
  Suspense,
  useEffect,
  useMemo,
  useRef,
  useState,
  MouseEvent,
} from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
// import { Broker } from "./interface";
import Form from "react-bootstrap/Form";
// import "./InputBox.scss";
import {
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_DensityState,
  type MRT_Row,
  MRT_SortingState,
  type MRT_TableOptions,
  MRT_VisibilityState,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { type User, fakeData, usStates } from "./makeData";
import { citiesList, usStateList } from "./makeData";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { Col, Container, Row } from "reactstrap";
import axiosInstance from "../../Utils/axiosInstance";
import { backendbaseUrl } from "../../Utils/baseUrl";
import { toast } from "react-toastify";
import { StyledTableFirstSecond } from "../Book/TableBook";
import { showDeleteConfirmModal } from "../../Components/ConfirmModal";
import {
  CompactTextField,
  CompactSelect,
} from "../../Components/SharedComponents/SharedComponents";
import FileUpload from "../../Components/FileUpload/FileUpload";
import BrokerTemplateDownloadButton from "../../Components/TemplateDownloadButton/BrokerTemplateDownloadButton";
interface Contract {
  id: string;
  contract_name: string;
}
interface Clearer {
  id: string;
  name: string;
}
interface FormData {
  contract: string;
  apply_mode: string;
  clearer: string;
  brokerage: string;
}

interface FormErrors {
  contract: string;
  apply_mode: string;
  clearer: string;
  brokerage: string;
}

interface Touched {
  contract: boolean;
  apply_mode: boolean;
  clearer: boolean;
  brokerage: boolean;
}
const QUERY_KEY = ["brokerages"];
const Example = () => {
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const isFirstRender = useRef(true);
  const [filterModes, setFilterModes] = useState<
    { mode: string; id: string; value: unknown }[]
  >([]);

  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [columnVisibility, setColumnVisibility] = useState<MRT_VisibilityState>(
    {}
  );
  const [density, setDensity] = useState<MRT_DensityState>("comfortable");
  const [globalFilter, setGlobalFilter] = useState<string | undefined>(
    undefined
  );
  const [showGlobalFilter, setShowGlobalFilter] = useState(true);
  const [showColumnFilters, setShowColumnFilters] = useState(true);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);

  const [inputBackgroundColour, setInputBackgroundColour] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 100, //set different default page size by initializing the state here
  });

  const addButtonRef = useRef<HTMLButtonElement | null>(null);
  const [showRowResizing, setShowRowResizing] = useState<boolean>(true);
  const [totalCount, setTotalCount] = useState(0);

  const [contracts, setContracts] = useState<Contract[]>([]);
  const [selectedContract, setSelectedContract] = useState<string>("");

  const [clearers, setClearers] = useState<Clearer[]>([]);
  const [selectedClearers, setSelectedClearers] = useState<string>("");

  const [selectApplayMode, setSelectApplayMode] = useState("");
  const [selecClearerText, setSelecClearerText] = useState("");

  const [brokerageFees, setBrokerageFees] = useState<string>("");
  const [formData, setFormData] = useState({
    contract: "",
    apply_mode: "",
    clearer: "",
    brokerage: "",
  });
  const [formErrors, setFormErrors] = useState({
    contract: "",
    apply_mode: "",
    clearer: "",
    brokerage: "",
  });
  const [touched, setTouched] = useState({
    contract: false,
    apply_mode: false,
    clearer: false,
    brokerage: false,
  });

  const [openFileUpload, setOpenFileUpload] = useState<boolean>(false);
  const handleFileUploadOpen = () => setOpenFileUpload(true);
  const handleFileUploadClose = () => setOpenFileUpload(false);

  const handleFileUploadSubmit = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file); // The key should match your API expectation

    try {
      const response = await axiosInstance.post(
        `${backendbaseUrl}/paper-app/upload/brokerage/`, // Update endpoint
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Refresh table data after successful upload
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });

      return {
        success: true,
        message: "File uploaded and data added successfully!",
        data: response.data,
      };
    } catch (error: any) {
      const backendError =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.response?.data?.detail ||
        "Failed to upload file";
      return { success: false, message: backendError };
    }
  };
  const handleFormChange = (field: keyof FormErrors, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Validate field on change
    validateField(field, value);

    // Special handling for apply_mode
    if (field === "apply_mode") {
      if (value === "10") {
        // Clear broker selection and error for Generic mode
        setFormData((prev) => ({
          ...prev,
          clearer: "",
        }));
        setFormErrors((prev) => ({
          ...prev,
          clearer: "",
        }));
        setTouched((prev) => ({
          ...prev,
          clearer: false,
        }));
      } else if (value === "20" && formData.clearer) {
        // Re-validate clearer if switching to Only For mode
        validateField("clearer", formData.clearer);
      }
    }
  };
  // Handle blur events
  const handleBlur = (field: keyof FormData, value: string): string | null => {
    // Mark field as touched
    setTouched((prev) => ({
      ...prev,
      [field]: true,
    }));

    // Run validation and return the error message or null
    const error = validateField(field, value);
    return error || null;
  };

  // Handle focus events
  const handleFocus = (field: keyof FormData) => {
    // Clear error when field is focused
    if (formErrors[field]) {
      setFormErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  // Validate individual field
  const validateField = (field: keyof FormData, value: string) => {
    let error = "";

    switch (field) {
      case "contract":
        if (!value) error = "Contract is required";
        else if (!contracts.some((c) => c.id === value))
          error = "Invalid contract selected";
        break;

      case "apply_mode":
        if (!value) error = "Apply Mode is required";
        else if (!["10", "20"].includes(value))
          error = "Invalid apply mode selected";
        break;

      case "clearer":
        if (!formData.apply_mode) {
          error = "Please select a Broker after choosing Apply Mode";
        } else if (formData.apply_mode === "20" && !value) {
          error = "Broker is required for Only For mode";
        } else if (formData.apply_mode === "20" && value) {
          // Validate that the selected clearer ID exists in clearers
          const clearerExists = clearers.some((c) => c.id === value);
          if (!clearerExists) {
            error = "Invalid broker selected";
          }
        }
        break;

      case "brokerage":
        if (!value) {
          error = "Brokerage is required";
        } else if (isNaN(Number(value))) {
          error = "Brokerage must be a number";
        } else if (Number(value) < 0) {
          error = "Brokerage cannot be negative";
        }
        break;
    }

    setFormErrors((prev) => ({
      ...prev,
      [field]: error,
    }));

    return error;
  };

  // Validate entire form
  const validateForm = () => {
    const errors = {
      contract: validateField("contract", formData.contract),
      apply_mode: validateField("apply_mode", formData.apply_mode),
      clearer: validateField("clearer", formData.clearer),
      brokerage: validateField("brokerage", formData.brokerage),
    };

    return !Object.values(errors).some((error) => error);
  };
  useEffect(() => {
    const fetchContracts = async () => {
      try {
        const res = await axiosInstance.get<Contract[]>(
          `${backendbaseUrl}/paper-app/brokerage-contracts/`
        );
        console.log(res.data);
        setContracts(res.data);
      } catch (err) {
        console.error("Error fetching contracts:", err);
      }
    };

    fetchContracts();
  }, []);

  useEffect(() => {
    const fetchClearer = async () => {
      try {
        const res = await axiosInstance.get<Clearer[]>(
          `${backendbaseUrl}/paper-app/brokerage-brokers/`
        );
        console.log("clearer", res.data);
        setClearers(res.data);
      } catch (err) { }
    };
    fetchClearer();
  }, []);

  const handleChangeClearer = (event: SelectChangeEvent<string>) => {
    setSelectedClearers(event.target.value);
  };
  const handleChangeContract = (event: SelectChangeEvent<string>) => {
    setSelectedContract(event.target.value);
  };

  const handleApplayMode = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    console.log("Selected Apply Mode:", value);
    setSelectApplayMode(value);
    if (value === "10") {
      setSelectedClearers(""); // Clear broker selection for Generic mode
    }
  };

  const handleCleare = (event: SelectChangeEvent) => {
    setSelecClearerText(event.target.value);
  };

  useEffect(() => {
    //do something when the pagination state changes
  }, [pagination]);

  useEffect(() => {
    const columnFilters = sessionStorage.getItem("mrt_columnFilters_table_1");
    const columnVisibility = sessionStorage.getItem(
      "mrt_columnVisibility_table_1"
    );
    const density = sessionStorage.getItem("mrt_density_table_1");
    const globalFilter = sessionStorage.getItem("mrt_globalFilter_table_1");
    const showGlobalFilter = sessionStorage.getItem(
      "mrt_showGlobalFilter_table_1"
    );
    const showColumnFilters = sessionStorage.getItem(
      "mrt_showColumnFilters_table_1"
    );
    const sorting = sessionStorage.getItem("mrt_sorting_table_1");

    if (columnFilters) {
      setColumnFilters(JSON.parse(columnFilters));
    }
    if (columnVisibility) {
      setColumnVisibility(JSON.parse(columnVisibility));
    }
    if (density) {
      setDensity(JSON.parse(density));
    }
    if (globalFilter) {
      setGlobalFilter(JSON.parse(globalFilter) || undefined);
    }
    if (showGlobalFilter) {
      setShowGlobalFilter(JSON.parse(showGlobalFilter));
    }
    if (showColumnFilters) {
      setShowColumnFilters(JSON.parse(showColumnFilters));
    }
    if (sorting) {
      setSorting(JSON.parse(sorting));
    }
    isFirstRender.current = false;
  }, []);

  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      "mrt_columnFilters_table_1",
      JSON.stringify(columnFilters)
    );
  }, [columnFilters]);
  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      "mrt_columnFilters_table_1",
      JSON.stringify(columnFilters)
    );

    console.log("columnFilters", "columnFilters---------------", columnFilters);
  }, [columnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      "mrt_columnVisibility_table_1",
      JSON.stringify(columnVisibility)
    );
  }, [columnVisibility]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem("mrt_density_table_1", JSON.stringify(density));
  }, [density]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      "mrt_globalFilter_table_1",
      JSON.stringify(globalFilter ?? "")
    );
  }, [globalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      "mrt_showGlobalFilter_table_1",
      JSON.stringify(showGlobalFilter)
    );
  }, [showGlobalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      "mrt_showColumnFilters_table_1",
      JSON.stringify(showColumnFilters)
    );
  }, [showColumnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem("mrt_sorting_table_1", JSON.stringify(sorting));
  }, [sorting]);

  const columns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "contract_name",
        header: "Contract",
        muiTableBodyCellProps: ({ row, table }) => ({
          onDoubleClick: () => {
            table.setEditingRow(row);
          },
          sx: {
            height: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
        muiEditTextFieldProps: ({ row, table }) => ({
          required: true,
          select: true,
          value: row.getValue("contract_name") ?? "",
          error: !!validationErrors?.contract_name,
          helperText: validationErrors?.contract_name,
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              contract_name: undefined,
            }),
          onChange: (e) => {
            const newValue = e.target.value;
            const selectedContract = contracts.find(
              (contract) => contract.contract_name === newValue
            );
            const newContractId = selectedContract?.id;
            console.log("newContractId", newContractId);

            const contractObj = {
              contract_name: newValue,
              contract_id: newContractId,
            };
            const updatedRow = {
              ...row.original,
              ...contractObj,
            };

            console.log("updatedRow", updatedRow);
            table.setEditingRow(updatedRow);
          },
          children: contracts.map((contract) => (
            <MenuItem key={contract.id} value={contract.contract_name}>
              {contract.contract_name}
            </MenuItem>
          )),
        }),
      },
      {
        accessorKey: "apply_mode",
        header: "Apply Mode",
        muiTableBodyCellProps: ({ row, table }) => ({
          onDoubleClick: () => {
            table.setEditingRow(row);
          },
          sx: {
            height: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
        muiEditTextFieldProps: ({ row, table }) => {
          const currentMode = row.getValue("apply_mode") ?? "";
          // Define available options based on current mode
          const availableModes =
            currentMode === "onlyfor"
              ? [{ key: "onlyfor", value: "Only For" }] // Only allow "Only For" if currently "Only For"
              : [
                { key: "generic", value: "Generic" },
                { key: "onlyfor", value: "Only For" },
              ]; // Allow both if currently "Generic"

          return {
            required: true,
            select: true,
            value: currentMode,
            error: !!validationErrors?.apply_mode,
            helperText: validationErrors?.apply_mode,
            onFocus: () =>
              setValidationErrors((prev) => ({
                ...prev,
                apply_mode: undefined,
              })),
            onChange: (e) => {
              const newValue = e.target.value;
              console.log("newValue", newValue);
              const updatedRow = {
                ...row.original,
                apply_mode: newValue,
                broker_name:
                  newValue === "generic" ? "" : row.original.broker_name,
              };
              table.setEditingRow(updatedRow);
            },
            children: availableModes.map((mode) => (
              <MenuItem key={mode.key} value={mode.key}>
                {mode.value}
              </MenuItem>
            )),
          };
        },
      },

      {
        accessorKey: "broker_name",
        header: "Broker Name",
        muiTableBodyCellProps: ({ row, table }) => ({
          onDoubleClick: () => {
            table.setEditingRow(row);
          },
          sx: {
            height: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
        muiEditTextFieldProps: ({ row, table }) => {
          const isGeneric = row.getValue("apply_mode") === "generic";
          return {
            required: !isGeneric,
            select: true,
            disabled: isGeneric,
            value: row.getValue("broker_name") ?? "",
            error: !!validationErrors?.broker_name,
            helperText: validationErrors?.broker_name,
            onFocus: () =>
              setValidationErrors((prev) => ({
                ...prev,
                broker_name: undefined,
              })),
            onChange: (e) => {
              const newValue = e.target.value;
              const selectedClearer = clearers.find(
                (clearer) => clearer.name === newValue
              );

              // Validate the selected clearer
              let error = "";
              if (!isGeneric && !newValue) {
                error = "Broker is required for Only For mode";
              } else if (!isGeneric && newValue && !selectedClearer) {
                error = "Invalid broker selected";
              }

              setValidationErrors((prev) => ({
                ...prev,
                broker_name: error,
              }));

              const updatedRow = {
                ...row.original,
                broker_name: newValue,
                clearer_id: selectedClearer?.id,
              };

              table.setEditingRow(updatedRow);
            },
            children: clearers
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((clearer) => (
                <MenuItem key={clearer.id} value={clearer.name}>
                  {clearer.name}
                </MenuItem>
              )),
          };
        },
        Cell: ({ row }) => {
          return row.getValue("broker_name") || "";
        },
      },
      {
        accessorKey: "brokerage",
        header: "Brokerage",
        muiTableBodyCellProps: ({ row, table }) => ({
          onDoubleClick: () => {
            table.setEditingRow(row);
          },
          sx: {
            height: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.brokerage,
          helperText: validationErrors?.brokerage,
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              brokerage: undefined,
            }),
        },
      },
    ],
    [validationErrors, clearers, contracts]
  );
  //call CREATE hook
  const { mutateAsync: createUser, isPending: isCreatingUser } =
    useCreateUser();
  //call READ hook
  const {
    data,
    isError: isLoadingUsersError,
    isFetching: isFetchingUsers,
    isLoading: isLoadingUsers,
  } = useGetData(filterModes, pagination, setTotalCount, sorting);
  //call UPDATE hook

  const { mutateAsync: updateUser, isPending: isUpdatingUser } = useUpdateUser(
    contracts,
    clearers
  );
  //call DELETE hook
  const { mutateAsync: deleteUser, isPending: isDeletingUser } =
    useDeleteUser();

  // CREATE FUNCTION TO ADD NEW A BROKER
  const createBroker = async (broker: { id: string; name: string }) => {
    if (!broker.name) {
      toast.error("Broker name is required!");
      return;
    }

    try {
      // Make an API call to add the broker
      await axiosInstance.post(
        `${backendbaseUrl}/paper-app/brokerages/`,
        broker
      );

      // Invalidate the query to refetch the updated data
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });

      // Show a success message
      toast.success("Broker added successfully!");
    } catch (error) {
      console.error("Error adding broker:", error);
      toast.error("Failed to add broker. Please try again.");
    }
  };
  // create by submitting the form
  const formCreate = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    // Mark all fields as touched to show errors
    setTouched({
      contract: true,
      apply_mode: true,
      clearer: true,
      brokerage: true,
    });

    // Validate entire form
    const isValid = validateForm();

    // If validation fails, collect all error messages and show them in a single toast
    if (!isValid) {
      const errorMessages = Object.values(formErrors)
        .filter((error) => error) // Only include non-empty error messages
        .join("; "); // Join errors with a semicolon for readability

      toast.error(
        errorMessages
          ? `Please correct the following errors: ${errorMessages}`
          : "Please fill all required fields correctly"
      );
      return;
    }

    // Map apply_mode to API-expected values
    const isGeneric = formData.apply_mode === "10";
    const applyMode = isGeneric ? "generic" : "onlyfor";

    // Create the payload
    const newClearerRate = {
      contract_input: formData.contract,
      apply_mode: applyMode,
      brokerage: parseFloat(formData.brokerage),
      ...(isGeneric ? {} : { broker: formData.clearer }),
    };

    console.log("Sending data to API:", newClearerRate);

    try {
      const response = await axiosInstance.post(
        `${backendbaseUrl}/paper-app/brokerages/`,
        newClearerRate
      );

      console.log("API Response:", response.data);

      // Reset form fields
      setFormData({
        contract: "",
        apply_mode: "",
        clearer: "",
        brokerage: "",
      });

      // Reset errors and touched state
      setFormErrors({
        contract: "",
        apply_mode: "",
        clearer: "",
        brokerage: "",
      });
      setTouched({
        contract: false,
        apply_mode: false,
        clearer: false,
        brokerage: false,
      });

      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
      toast.success("Brokerage added successfully!");
    } catch (error: any) {
      console.error("Error adding brokerage:", error);

      // toast.error("Failed to add Brokerage. Please try again.");
      let errorMessage = "Failed to add Brokerage. Please try again.";

      // Handle the specific error structure
      if (error.response?.data?.error) {
        const errorString = error.response.data.error;

        // Extract message from string format like "{'non_field_errors': [ErrorDetail(string='...', code='invalid')]}"
        const match = errorString.match(/string='([^']+)'/);
        if (match && match[1]) {
          errorMessage = match[1];
        } else {
          errorMessage = errorString;
        }
      } else if (error.response?.data?.non_field_errors?.length > 0) {
        // Handle proper JSON structure (your original code)
        const firstError = error.response.data.non_field_errors[0];
        if (firstError.string) {
          errorMessage = firstError.string;
        }
      } else if (error.response?.data?.detail?.string) {
        errorMessage = error.response.data.detail.string;
      } else if (error.response?.data?.detail) {
        errorMessage =
          typeof error.response.data.detail === "string"
            ? error.response.data.detail
            : errorMessage;
      } else if (error.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    } finally {
      // Reset form fields regardless of success or error
      setFormData({
        contract: "",
        apply_mode: "",
        clearer: "",
        brokerage: "",
      });

      // Reset errors and touched state
      setFormErrors({
        contract: "",
        apply_mode: "",
        clearer: "",
        brokerage: "",
      });
      setTouched({
        contract: false,
        apply_mode: false,
        clearer: false,
        brokerage: false,
      });

      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    }
  };
  const handleCreateUser: MRT_TableOptions<User>["onCreatingRowSave"] = async ({
    values,
    table,
  }) => {
    // Validate the input values
    const newValidationErrors = validateUser(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }

    setValidationErrors({});
    // Only include 'clearer' if not generic
    const isGeneric = values.apply_mode === "10";
    const newClearerRate: any = {
      contract_input: values.contract,
      apply_mode: isGeneric ? "generic" : "Only For",
      brokerage: parseFloat(values.brokerage),
      ...(isGeneric ? {} : { clearer: values.clearer }),
    };

    await createBroker(newClearerRate);

    // Exit creating mode
    table.setCreatingRow(null);
  };

  //UPDATE action
  //UPDATE action
  const handleeditsave: MRT_TableOptions<User>["onEditingRowSave"] = async ({
    values,
    table,
    row,
  }) => {
    console.log("Saving User - Edited Values:", values);
    console.log("Saving User - Original Row Data:", row.original);

    // Prepare the updated user object for the API
    const isGeneric = values.apply_mode === "generic";

    // Find the contract ID based on the contract name
    const selectedContract = contracts.find(
      (contract) => contract.contract_name === values.contract_name
    );

    // For non-generic mode, find the broker ID based on the selected name
    let brokerId = null;
    if (!isGeneric && values.broker_name) {
      // Important: values.broker_name might already be the ID in your current form
      // Check if it's already an ID (exists in clearers)
      const brokerExists = clearers.find(
        (clearer) => clearer.id === values.broker_name
      );

      if (brokerExists) {
        // It's already an ID
        brokerId = values.broker_name;
      } else {
        // Try to find the ID by name
        const brokerByName = clearers.find(
          (clearer) => clearer.name === values.broker_name
        );
        brokerId = brokerByName?.id;
      }

      if (!brokerId) {
        console.error("Could not find Brokerage ID for:", values.broker_name);
        toast.error("Invalid Brokerage selected. Please try again.");
        return;
      }
    }

    const updatedUser = {
      ...row.original, // Retain original data
      contract_input: selectedContract?.id, // Use contract ID, not name
      apply_mode: values.apply_mode, // Should be "generic" or "Only For"
      brokerage: parseFloat(values.brokerage), // Ensure numeric value
      ...(isGeneric ? {} : { broker: brokerId }), // Include broker ID only if not generic
    };

    console.log("Saving User - API Payload:", updatedUser);

    // Validate the updated user data
    const newValidationErrors = validateUser(updatedUser);
    if (Object.values(newValidationErrors).some((error) => error)) {
      console.log("Validation Errors:", newValidationErrors);
      setValidationErrors(newValidationErrors);
      return;
    }

    setValidationErrors({});

    try {
      await updateUser(updatedUser);
      table.setEditingRow(null);
      toast.success("brokerages updated successfully!");
    } catch (error) {
      console.error("User Update Error:", error);
      toast.error("Failed to update brokerage. Please try again.");
    }
  };

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<User>) => {
    showDeleteConfirmModal({
      title: "Are you sure you want to delete this brokerage?",
      content: "Deleting brokerage...",
      onOk: () => {
        deleteUser(row.original.id)
          .then(() => {
            toast.success("brokerages deleted successfully!");
          })
          .catch((error) => {
            toast.error("Failed to delete brokerage. Please try again.");
          });
      },
    });
  };

  const handleCopyRow = (row: MRT_Row<any>) => {
    if (!row || !row.original) {
      toast.error("No brokerage row data to copy");
      return;
    }

    const { contract_name, apply_mode, broker_name, brokerage } = row.original;

    // Log row data for debugging
    console.log("Row data:", {
      contract_name,
      apply_mode,
      broker_name,
      brokerage,
    });

    // Find the contract by name
    const matchedContract = contracts.find(
      (c) => c.contract_name?.toLowerCase() === contract_name?.toLowerCase()
    );

    if (!matchedContract) {
      toast.error(
        `Contract "${contract_name || "unknown"}" not found in options`
      );
      return;
    }

    // Map apply_mode to form values ("10" for Generic, "20" for Only For)
    const mappedApplyMode = apply_mode === "generic" ? "10" : "20";

    // Find the broker by name (only for "onlyfor" mode)
    let matchedClearer = null;
    if (apply_mode === "onlyfor" && broker_name) {
      matchedClearer = clearers.find(
        (c) => c.name?.toLowerCase() === broker_name?.toLowerCase()
      );
      if (!matchedClearer) {
        toast.error(
          `Broker "${broker_name || "unknown"}" not found in options`
        );
        return;
      }
    }

    // Update formData state with the copied values
    setFormData({
      contract: matchedContract.id,
      apply_mode: mappedApplyMode,
      clearer: apply_mode === "onlyfor" ? matchedClearer?.id || "" : "",
      brokerage: brokerage != null ? String(brokerage) : "",
    });

    // Update individual state variables (optional, for consistency)
    setSelectedContract(matchedContract.id || "");
    setSelectApplayMode(mappedApplyMode);
    setSelectedClearers(
      apply_mode === "onlyfor" ? matchedClearer?.id || "" : ""
    );
    setBrokerageFees(brokerage != null ? String(brokerage) : "");

    // UI feedback
    window.scrollTo({ top: 0, behavior: "smooth" });
    setInputBackgroundColour("#83bf6e26");
    setTimeout(() => setInputBackgroundColour(""), 2400);
    toast.success("brokerage Row data copied to form");

    // Log updated formData for debugging
    console.log("Updated formData:", {
      contract: matchedContract.id,
      apply_mode: mappedApplyMode,
      clearer: apply_mode === "onlyfor" ? matchedClearer?.id || "" : "",
      brokerage: brokerage != null ? String(brokerage) : "",
    });
  };

  interface ContextMenuPosition {
    mouseX: number;
    mouseY: number;
  }

  const [contextMenu, setContextMenu] = useState<ContextMenuPosition | null>(
    null
  );

  // Function to handle right-click and open the menu
  const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 }
        : null
    );
  };

  // Function to handle menu close
  const handleClose = () => {
    setContextMenu(null);
  };

  // Function to handle Paste action
  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      let jsonData;

      try {
        jsonData = JSON.parse(text);
        setBrokerageFees(jsonData.name);
        window.scrollTo({ top: 0, behavior: "smooth" });
        toast.success("copied and pasted successfully");
        setInputBackgroundColour("#83bf6e26");
        setTimeout(() => {
          setInputBackgroundColour(""); // Then set it again
        }, 2400);
      } catch (error) {
        console.error("Invalid JSON. Pasted as a string:", text);
        jsonData = { rawText: text }; // Fallback if not valid JSON
      }

      // Here, you can use jsonData further as needed
    } catch (err) {
      console.error("Failed to read clipboard contents:", err);
    }

    handleClose();
  };

  // Function to handle Mark action
  const handleResizing = () => {
    setShowRowResizing(!showRowResizing);
    handleClose();
  };

  const handleExportRows = async (rows: MRT_Row<any>[]) => {
      if (rows.length === 0) {
        toast.warn("Please select at least one row to export");
        return;
      }
  
      try {
        const rowIds = rows.map((row) => row.original.id);
        const response = await axiosInstance.post(
          `${backendbaseUrl}/paper-app/brokerage/select-export/`,
          { ids: rowIds },
          {
            responseType: "blob",
          }
        );
  
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "selected_brokerage.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  
        toast.success("Export started successfully");
      } catch (error) {
        console.error("Export error:", error);
        toast.error("Failed to export selected rows");
      }
    };

  const handleDataDownload = async () => {
    try {
      const response = await axiosInstance.get(
        "/paper-app/brokerage/export-delete/",
        {
          responseType: "blob", // Ensure Axios handles binary data properly
        }
      );

      // Create a blob from the response data
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = "brokerages.csv"; // Set the file name
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Cleanup the URL object
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading CSV:", error);
    }
  };
  const handleBulkDelete = async (rows: MRT_Row<any>[]) => {
    // Extract IDs from the selected rows
    const rowIds = rows.map((row) => row.original.id);

    if (rowIds.length === 0) {
      toast.warn("No rows selected for deletion.");
      return;
    }

    try {
      // Show confirmation dialog before deleting
      showDeleteConfirmModal({
        title: `Delete ${rowIds.length} selected brokerage(s)?`,
        content: `You are about to delete ${rowIds.length} brokerage(s). This action cannot be undone.`,
        onOk: async () => {
          try {
            // Show loading indicator
            const loadingToast = toast.loading(
              `Deleting ${rowIds.length} brokerage(s)...`
            );

            // Log what we're sending to help debug
            console.log("Attempting to delete IDs:", rowIds);

            // Make the DELETE request
            const response = await axiosInstance.delete(
              `${backendbaseUrl}/paper-app/brokerage/export-delete/`,
              {
                data: { ids: rowIds },
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            // Check response
            console.log("Delete response:", response);

            if (response.status === 200) {
              toast.success(
                `${rowIds.length} brokerage(s) deleted successfully!`
              );
              // Refresh the data
              queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
              // Clear selection after deletion
              table.setRowSelection({});
            } else {
              toast.error(
                `Failed to delete brokerages: ${
                  response.data?.message ||
                  response.data?.detail ||
                  "Unknown error"
                }`
              );
            }

            // Dismiss loading toast
            toast.dismiss(loadingToast);
          } catch (error: any) {
            console.error("Bulk delete error:", error);

            // Enhanced error logging
            console.error("Error details:", {
              message: error.message,
              status: error.response?.status,
              data: error.response?.data,
            });

            // Detailed error message
            const errorMessage =
              error.response?.data?.message ||
              error.response?.data?.detail ||
              error.message ||
              "Failed to delete brokerages";

            toast.error(`Error: ${errorMessage}`);

            // Alternative endpoint suggestion if the current one doesn't exist
            if (error.response?.status === 404) {
              console.warn(
                "The endpoint may not exist. Try another endpoint such as:"
              );
              console.warn("- /paper-app/clearer-rates/bulk-delete/");
              console.warn("- /paper-app/clearer-rate-bulk-delete/");
              toast.info(
                "Note: The bulk delete endpoint might not be implemented on the server"
              );
            }
          }
        },
      });
    } catch (error) {
      console.error("Error in delete confirmation:", error);
      toast.error("An error occurred during deletion. Please try again.");
    }
  };
  const table = useMaterialReactTable({
    columns,

    enableStickyHeader: true,
    enableStickyFooter: true,
    enableClickToCopy: true,
    enableKeyboardShortcuts: true,
    // enableRowNumbers: true,
    enableColumnActions: true,
    enableColumnDragging: true,
    enableGlobalFilter: false,
    enableGrouping: true,
    enableHiding: true,
    enableSorting: true,
    enableColumnPinning: true,
    onPaginationChange: setPagination,
    onColumnFiltersChange: setColumnFilters,
    onColumnVisibilityChange: setColumnVisibility,
    onDensityChange: setDensity,
    onGlobalFilterChange: setGlobalFilter,
    onShowColumnFiltersChange: setShowColumnFilters,
    onShowGlobalFilterChange: setShowGlobalFilter,
    onSortingChange: setSorting,
    manualSorting: true,
    manualPagination: true,
    enableRowSelection: true,
    // positionToolbarAlertBanner: "bottom",
    // layoutMode: "semantic",
    // enableColumnResizing: showRowResizing,
    enableColumnResizing: true, // Already set
    // columnResizeMode: "onEnd", // Ensures precise resizing
    // defaultColumn: {
    //   minSize: 50, // Smallest practical width
    //   enableResizing: true,
    // },
    enableFilterMatchHighlighting: true,
    rowCount: totalCount,
    manualFiltering: true,
    data: data?.results || [],
    enableDensityToggle: false,
    createDisplayMode: "row", // ('modal', and 'custom' are also available)
    editDisplayMode: "row", // ('modal', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,
    // Top toolbar customization
    muiTopToolbarProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
        // Optional: Style the inner MuiBox-root (css-wsew38) for visual confirmation
        "& .MuiBox-root.css-wsew38": {
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        },
      },
      className: "top-toolbar-wrapper__new",
    }),

    muiTableContainerProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
      },
      className: "table-container-wrapper__new",
    }),
    muiTableFooterProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
      },
      className: "table-footer-wrapper__new",
    }),
    muiBottomToolbarProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
      },
      className: "bottom-toolbar-wrapper__new",
    }),

    muiTableBodyRowProps: ({ row, table }) => ({
      onKeyDown: (event: React.KeyboardEvent<HTMLTableRowElement>) => {
        if (event.key === "Enter") {
          event.preventDefault();

          const editingRow = table.getState().editingRow;
          if (editingRow) {
            const saveHandler = table.options.onEditingRowSave;
            if (saveHandler) {
              const newedit = {
                ...editingRow.original,
                ...editingRow._valuesCache,
              };
              console.log("Saving:", newedit);

              saveHandler({
                exitEditingMode: () => table.setEditingRow(null),
                row: editingRow,
                table,
                values: newedit,
              });
            }
          }
        }
      },
    }),

    enableColumnOrdering: true, // ✅ Enables column drag-and-drop
    enableRowOrdering: false, // ✅ Enables row drag-and-drop
    getRowId: (row) => row.id,
    enableColumnFilterModes: true, //enable changing filter mode for all columns unless explicitly disabled in a column def
    // initialState: { showColumnFilters: true }, //show filters by default
    filterFns: {
      customFilterFn: (row, id, filterValue) => {
        return row.getValue(id) === filterValue;
      },
    },

    defaultDisplayColumn: {
      enableResizing: true, //turn on some features that are usually off for all display columns
    },
    displayColumnDefOptions: {
      "mrt-row-actions": {
        enableColumnActions: true,
        size: 120, //set custom width
        muiTableHeadCellProps: {
          // align: "center", //change head cell props
        },
      },
      "mrt-row-numbers": {
        enableColumnDragging: true,
        enableColumnOrdering: true, //turn on some features that are usually off
        enableResizing: true,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "1.2rem",
          },
        },
      },
      "mrt-row-select": {
        enableColumnActions: true,
        enableHiding: true,
        // size: 50,
      },
    },

    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        className="table-download__wrapper"
        sx={{
          display: "flex",
          gap: "6px",
          padding: "0px",
          flexWrap: "wrap",
        }}
      >
        <Button startIcon={<UploadFileIcon />} onClick={handleFileUploadOpen}>
          Upload File
        </Button>
        <Button
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={() => handleDataDownload()}
          startIcon={<BrowserUpdatedIcon />}
        >
          Export All Data
        </Button>
        <BrokerTemplateDownloadButton
          apiEndpoint="/paper-app/download-brokerage-template/"
          buttonText="Download Template"
          fileName="brokerage_template.csv"
        />
        {/* <Button
          disabled={table.getPrePaginationRowModel().rows.length === 0}
          //export all rows, including from the next page, (still respects filtering and sorting)

          startIcon={<FileDownloadIcon />}
        >
          Export All Rows
        </Button>
        <Button
          disabled={table.getRowModel().rows.length === 0}
          //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)

          startIcon={<FileDownloadIcon />}
        >
          Export Page Rows
        </Button> */}
        <Button
          disabled={
            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
          }
          //only export selected rows
          onClick={() =>
            handleExportRows(table.getSelectedRowModel().rows as any)
          }
          startIcon={<FileDownloadIcon />}
        >
          Export Selected Rows
        </Button>
        {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) && (
          <Button
            style={{ color: "red" }}
            onClick={() => handleBulkDelete(table.getSelectedRowModel().rows)}
            startIcon={<DeleteIcon />}
          >
            Delete Selected ({table.getSelectedRowModel().rows.length})
          </Button>
        )}
      </Box>
    ),

    // muiTableProps: {
    //   sx: {
    //     border: '1px solid rgba(81, 81, 81, .5)',
    //     caption: {
    //       captionSide: 'top',
    //     },
    //   },
    // },
    muiTableHeadCellProps: {
      sx: {
        border: "1px solid #e0e0e087",
        fontStyle: "normal",
        fontWeight: "normal",
      },
    },

    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "0",
        border: "0",
      },
    },
    localization: {
      filterCustomFilterFn: "Custom Filter Fn",
    } as any,

    muiToolbarAlertBannerProps: isLoadingUsersError
      ? {
        color: "error",
        children: "Error loading data",
      }
      : undefined,

    onCreatingRowCancel: () => setValidationErrors({}),
    onCreatingRowSave: handleCreateUser,
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleeditsave,

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Edit" className="editIcon">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete" className="deleteIcon">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Copy Row">
          <IconButton onClick={() => handleCopyRow(row)}>
            {" "}
            {/* ✅ Pass row as argument */}
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    state: {
      sorting,
      columnFilters,
      pagination,
      isLoading: isLoadingUsers,
      isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
      showAlertBanner: isLoadingUsersError,
      showProgressBars: isFetchingUsers,
      showColumnFilters: true,
    },
  });

  const transformedFilters = columnFilters.map((filter) => ({
    ...filter,
    mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
  }));

  useEffect(() => {
    const transformedFilters = columnFilters.map((filter) => ({
      ...filter,
      mode:"contains",
    }));

    setFilterModes(transformedFilters);
  }, [columnFilters, table]);

  const someEventHandler = (event: any) => {
    console.info("rows :", table.getRowModel().rows); //example - get access to all page rows in the table
    console.info("row model :", table.getSelectedRowModel()); //example - get access to all selected rows in the table
    console.info("row model :", table.getState().sorting); //example - get access to the current sorting state without having to manage it yourself
  };
  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <div>
            <div className="table-ad">
              <Accordion defaultActiveKey="0" className="table-ad__addInputs">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="accordion_button">
                    Add New Brokerage
                  </Accordion.Header>
                  <Accordion.Body>
                    <Form onSubmit={formCreate}>
                      <div className="form_contain">
                        <div
                          className={`flex formWrapper ${inputBackgroundColour !== "" ? "inputboxcustom" : ""
                            }`}
                          style={{ backgroundColor: inputBackgroundColour }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              p: { xs: 1, sm: 1 },
                              pt: "20px !important",
                              backgroundColor: "#ffff",
                              borderRadius: "4px",
                              border: "1px solid #e0e0e0",
                            }}
                          >
                            <Box
                              className="form_default"
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "flex-start",
                                justifyContent: "start",
                                gap: 0.5,
                                "& > *": {
                                  minWidth: {
                                    xs: "100%",
                                    sm: "48%",
                                    md: "23%",
                                    lg: "15%",
                                    xl: "7.5%",
                                  },
                                },
                              }}
                            >
                              {/* Contract Field */}
                              <CompactSelect
                                label="Contract"
                                value={formData.contract}
                                onChange={(value) =>
                                  handleFormChange("contract", value)
                                }
                                name="contract"
                                options={contracts.map((contract) => ({
                                  value: contract.id,
                                  label: contract.contract_name,
                                }))}
                                error={Boolean(
                                  formErrors.contract && touched.contract
                                )}
                                // helperText={
                                //   formErrors.contract && touched.contract
                                //     ? formErrors.contract
                                //     : ""
                                // }
                                validateOnBlur={(value) =>
                                  handleBlur("contract", value)
                                }
                                onFocus={() => handleFocus("contract")}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                              />

                              {/* Apply Mode Field */}
                              <CompactSelect
                                label="Apply Mode"
                                value={formData.apply_mode}
                                onChange={(value) =>
                                  handleFormChange("apply_mode", value)
                                }
                                name="apply_mode"
                                options={[
                                  { value: "10", label: "Generic" },
                                  { value: "20", label: "Only For" },
                                ]}
                                error={Boolean(
                                  formErrors.apply_mode && touched.apply_mode
                                )}
                                // helperText={
                                //   formErrors.apply_mode && touched.apply_mode
                                //     ? formErrors.apply_mode
                                //     : ""
                                // }
                                validateOnBlur={(value) =>
                                  handleBlur("apply_mode", value)
                                }
                                onFocus={() => handleFocus("apply_mode")}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                              />

                              {/* Broker Field */}
                              <CompactSelect
                                label="Broker"
                                value={formData.clearer}
                                onChange={(value) =>
                                  handleFormChange("clearer", value)
                                }
                                name="broker"
                                options={[...clearers]
                                  .sort((a, b) => a.name.localeCompare(b.name))
                                  .map((clearer) => ({
                                    value: clearer.id,
                                    label: clearer.name,
                                  }))}
                                disabled={formData.apply_mode === "10"}
                                error={Boolean(
                                  formErrors.clearer && touched.clearer
                                )}
                                // helperText={
                                //   formErrors.clearer && touched.clearer
                                //     ? formErrors.clearer
                                //     : ""
                                // }
                                validateOnBlur={(value) =>
                                  handleBlur("clearer", value)
                                }
                                onFocus={() => handleFocus("clearer")}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                              />

                              {/* Brokerage Field */}
                              <CompactTextField
                                label="Brokerage"
                                value={formData.brokerage}
                                onChange={(value) =>
                                  handleFormChange("brokerage", value)
                                }
                                name="brokerage"
                                error={Boolean(
                                  formErrors.brokerage && touched.brokerage
                                )}
                                // helperText={
                                //   formErrors.brokerage && touched.brokerage
                                //     ? formErrors.brokerage
                                //     : ""
                                // }
                                validateOnBlur={(value) =>
                                  handleBlur("brokerage", value)
                                }
                                onFocus={() => handleFocus("brokerage")}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                              />

                              <Button
                                variant="contained"
                                fullWidth
                                type="submit"
                                sx={{
                                  height: { xs: "36px", sm: "32px" },
                                  flex: { xs: "1 1 auto", sm: "0 0 auto" },
                                  minWidth: { xs: "100%", sm: "100px" },
                                  maxWidth: { sm: "150px" },
                                  backgroundColor: "#00bcd4",
                                  textTransform: "none",
                                  fontSize: "0.75rem",
                                  "&:hover": {
                                    backgroundColor: "#008c9e",
                                  },
                                }}
                              >
                                Add
                              </Button>
                            </Box>
                          </Box>
                        </div>
                      </div>
                    </Form>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <div
                className="table-ad__wrapper"
                onContextMenu={handleContextMenu}
              >
                <div className="table-ad__wrapperCard">
                  <MaterialReactTable table={table} />

                  {/* Context Menu */}
                  <Menu
                    open={contextMenu !== null}
                    onClose={handleClose}
                    anchorReference="anchorPosition"
                    anchorPosition={
                      contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                    }
                  >
                    {/* <MenuItem onClick={handlePaste}>Paste</MenuItem> */}
                    <MenuItem onClick={handleResizing}>
                      {showRowResizing ? "Disable Resizing" : "enable Resizing"}
                    </MenuItem>
                  </Menu>
                </div>
                <FileUpload
                  open={openFileUpload}
                  onFileUploadClose={handleFileUploadClose}
                  onFileUploadSubmit={handleFileUploadSubmit}
                  acceptedFileTypes=".csv,.json"
                />
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

//CREATE hook (post new user to api)X
function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (user: User) => {
      //send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (newUserInfo: User) => {
      queryClient.setQueryData(
        [QUERY_KEY],
        (prevUsers: any) =>
          [
            ...prevUsers,
            {
              ...newUserInfo,
              id: (Math.random() + 1).toString(36).substring(7),
            },
          ] as User[]
      );
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
  });
}

//READ hook (get users from api)
function useGetData(
  filterModes: { mode: string; id: string; value: unknown }[],
  pagination: { pageIndex: number; pageSize: number },
  setTotalCount: (count: number) => void,
  sorting: any
) {
  return useQuery<{ results: User[]; count: number }>({
    queryKey: [QUERY_KEY, filterModes, pagination, sorting],
    queryFn: async () => {
      let url = `${backendbaseUrl}/paper-app/brokerages/?page=${pagination.pageIndex + 1
        }&page_size=${pagination.pageSize}`;

      if (filterModes.length > 0) {
        const queryParams = filterModes
          .map((e) => `fieldName_${e.id}=${String(e.value)}_${e.mode}`)
          .join("&");
        url += `&${queryParams}`;
      }

      if (sorting.length > 0) {
        const sortParams = `sortField_${sorting[0].id}=${sorting[0].desc ? "desc" : "asc"
          }`;
        url += `&${sortParams}`;
      }

      const response = await axiosInstance.get(url);
      setTotalCount(response.data.count);
      return response.data;
    },
    refetchOnWindowFocus: false,
  });
}

function useUpdateUser(contracts: Contract[], clearers: Clearer[]) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (user: any) => {
      console.group("🔄 Clearer Rate Update");
      console.log("Input Object:", user);

      if (!user || !user.id) {
        console.error("❌ Invalid object:", user);
        throw new Error("Object is invalid or missing ID");
      }

      // Prepare the payload for the API - broker ID should already be correctly set in the user object
      const payload = {
        contract_input: user.contract_input, // Should be the ID
        apply_mode: user.apply_mode, // "generic" or "Only For"
        brokerage: user.brokerage,
        ...(user.apply_mode === "generic" ? {} : { broker: user.broker }), // Use broker field, not clearer
      };

      try {
        const { data } = await axiosInstance.put(
          `${backendbaseUrl}/paper-app/brokerages/${user.id}/`,
          payload
        );
        console.log("✅ API Response:", data);
        console.groupEnd();
        return data;
      } catch (error) {
        console.error("❌ API Request Failed:", error);
        throw error;
      }
    },
    onMutate: async (newUserInfo: any) => {
      console.log("🔮 Optimistic Update - New Info:", newUserInfo);
      await queryClient.cancelQueries({ queryKey: [QUERY_KEY] });
      const previousUsers = queryClient.getQueryData([QUERY_KEY]);
      queryClient.setQueryData([QUERY_KEY], (oldData: any) => {
        if (!oldData?.results) return oldData;

        // Find the contract and broker names for display
        const contractName =
          contracts.find((c) => c.id === newUserInfo.contract_input)
            ?.contract_name || "";
        const brokerName =
          clearers.find((c) => c.id === newUserInfo.broker)?.name || "";

        return {
          ...oldData,
          results: oldData.results.map((prevItem: any) =>
            prevItem.id === newUserInfo.id
              ? {
                ...prevItem,
                contract_name: contractName,
                apply_mode: newUserInfo.apply_mode,
                brokerage: newUserInfo.brokerage,
                broker_name:
                  newUserInfo.apply_mode === "generic" ? "" : brokerName,
              }
              : prevItem
          ),
        };
      });
      return { previousUsers };
    },
    onError: (err, newUser, context) => {
      console.error("❌ Update Failed:", err);
      queryClient.setQueryData([QUERY_KEY], context?.previousUsers);
      toast.error("Failed to update brokerages. Please try again.");
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
  });
}

//DELETE hook (delete user in api)
function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (userId: string) => {
      //send api update request here
      // await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      try {
        await axiosInstance.delete(
          `${backendbaseUrl}/paper-app/brokerages/${userId}/`
        );
        console.log("userId", userId);
      } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
      }

      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: async (userId: string) => {
      await queryClient.cancelQueries({ queryKey: [QUERY_KEY] });

      const previousUsers = queryClient.getQueryData([QUERY_KEY]);

      queryClient.setQueryData([QUERY_KEY], (prevUsers: any) =>
        prevUsers?.filter((user: User) => user.id !== userId)
      );

      return { previousUsers };
    },
    onError: (err, userId, context) => {
      console.error("❌ Delete Failed:", err);
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEY] }), //refetch users after mutation, disabled for demo
  });
}

//react query setup in App.tsx
const ReactQueryDevtoolsProduction = lazy(() =>
  import("@tanstack/react-query-devtools/build/modern/production.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Example />
      {/* <Suspense fallback={null}>
        <ReactQueryDevtoolsProduction />
      </Suspense> */}
    </QueryClientProvider>
  );
}

const validateRequired = (value: string) => !!value.length;
const validateEmail = (email: string) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

function validateUser(user: User) {
  return {
    // brokerName: !validateRequired(user.name)
    //   ? "First Name is Required"
    //   : "",
    // name: !validateRequired(user.name) ? "Last Name is Required" : "",
    // email: !validateEmail(user.email) ? "Incorrect Email Format" : "",
  };
}
